<template>
  <Page color="info" title="Benutzerkonten">
    <template slot="help">
      <Markdown :value="helpText" />
    </template>

    <v-container class="mb-4">
      <v-row class="align-center justify-center">
        <SchoolClassPicker outlined text v-model="schoolClass" />

        <v-spacer />

        <v-text-field
          type="search"
          dense
          single-line
          hide-details=""
          v-model="search"
          label="Schüler:in"
          append-icon="mdi-magnify"
          clearable
        />
      </v-row>
    </v-container>

    <v-card :loading="loading">
      <v-system-bar
        >Benutzerkonten {{ schoolClass ? schoolClass.code : "" }}</v-system-bar
      >
      <v-data-table
        item-key="person.id"
        :loading="loading"
        :headers="headers"
        hide-default-footer
        :items="itemsFiltered"
        disable-pagination
        :items-per-page="-1"
        sort-by="student"
      >
        <template v-slot:item.person="{ item }">
          <PersonItem small :value="item.person" />
        </template>
        <template v-slot:item.status="{ item }">
          <LookupValue :value="item.status" />
        </template>
        <template v-slot:item.policyAccepted="{ item }">
          <v-simple-checkbox
            v-model="item.policyAccepted"
            disabled
          ></v-simple-checkbox>
        </template>

        <template v-slot:footer
          ><TableFooter
            :items="itemsFiltered"
            label="Schüler:innen"
            labelSingular="Schüler:in"
          ></TableFooter
        ></template>
      </v-data-table>
    </v-card>
  </Page>
</template>

<script>
import { defineComponent } from "vue";
import LookupValue from "common/components/LookupValue.vue";
import PersonItem from "common/components/PersonItem.vue";
import SchoolClassPicker from "@/components/SchoolClassPicker.vue";
import TableFooter from "common/components/TableFooter.vue";
import { comparePeople, searchPerson } from "common/utils/people.js";

const helpText = `
`;

export default defineComponent({
  name: "Accounts",
  components: {
    LookupValue,
    PersonItem,
    SchoolClassPicker,
    TableFooter,
  },

  data() {
    return {
      helpText,
      loading: false,
      headers: [
        { text: "Schüler:in", value: "person", sort: comparePeople },
        {
          text: "Benutzername",
          value: "samAccountName",
          sortable: false,
          align: "center",
        },
        { text: "Status", value: "status" },
        {
          text: "Nutzungsrichtlinien akzeptiert",
          value: "policyAccepted",
          sortable: false,
          align: "center",
        },
      ],
      items: [],

      search: "",
      schoolClass: null,
    };
  },
  computed: {
    itemsFiltered() {
      return this.items.filter(
        (el) =>
          el.person.schoolClass.id == this.schoolClass.id &&
          (!this.search || searchPerson(el.student, this.search))
      );
    },
  },
  watch: {},
  methods: {
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "account/account",
      });
      this.loading = false;
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
